const STATE = {
  CONFIRM: {
    OPEN: 'open',
    CLOSED: 'closed',
  },
  DRAWER: {
    OPEN: 'open',
    CLOSED: 'closed',
  },
  OVERLAY: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  },
  MEGAMENU: {
    CLOSED: 'closed',
    OPEN: 'open',
  },
  MODAL: {
    OPEN: 'open',
    CLOSED: 'closed',
  },
  DESCRIPTION: {
    CLOSED: 'closed',
    OPEN: 'open',
  },
  SUBSCRIPTION: {
    SELECTOR: {
      SELECTED: {
        TRUE: 'true',
        FALSE: 'false',
      },
    },
    OPTIONS: {
      OPEN: 'open',
      CLOSED: 'closed',
    },
    OPTION: {
      SELECTED: {
        TRUE: 'true',
        FALSE: 'false',
      },
    },
  },
};

export default STATE;
